<template>
    <div class="cinema-room page">
        <div class="header flex">
            <div>
                <div class="filme-name">{{ filmeName }}</div>
                <div class="filme-location">{{ filmeAddress }}</div>
            </div>
            <div class="location-img" @click="toMap">
                <img :src="require('@/assets/icons/icon-address-44x44.png')" />
            </div>
        </div>
        <div class="swipe-box">
            <div class="swiper-container">
                <img
                    class="swipe-bac"
                    :src="movieList[movieIndex] ? movieList[movieIndex].pic : ''"
                />
                <div class="swiper-wrapper">
                    <div
                        class="swiper-slide"
                        v-for="(item, index) in movieList"
                        :class="{ scal: index == movieIndex }"
                        :key="index"
                    >
                        <img class="img" @click="clickSwiperImg(index)" :src="item.pic" />
                    </div>
                </div>
            </div>
        </div>
        <div class="cinema-content">
            <div class="cinema-name">
                <span>{{ movieList[movieIndex] ? movieList[movieIndex].name : '' }}</span>
                <span class="grade">
                    {{ movieList[movieIndex] ? movieList[movieIndex].grade : '' }}
                </span>
            </div>
            <div class="cinema-detail">
                <span>
                    {{ movieList[movieIndex] ? movieList[movieIndex].duration : '' }}分钟 丨
                    {{ movieList[movieIndex] ? movieList[movieIndex].filmType : '' }} 丨
                    {{ movieList[movieIndex] ? movieList[movieIndex].cast : '' }}
                </span>
            </div>
        </div>
        <div class="date-list flex" :class="{ 'more-date': dateList.length > 3 }">
            <div
                class="date-item"
                :class="{ select: index == dateIndex }"
                v-for="(item, index) in dateList"
                @click="switchDate(index)"
                :key="index"
            >
                <div class="text">
                    <span class="week">{{ item.week }}</span>
                    <span class="date">{{ item.month }}/{{ item.day }}</span>
                </div>
            </div>
        </div>
        <div class="filme-list iphone-x-adaptation">
            <div
                class="filme-item"
                v-for="(item, index) in filmeList"
                @click="toSeatSelect(item)"
                :key="index"
            >
                <div class="time">
                    <!-- <div class="show-tip" v-if="item.startAt == '00:00'">次日放映</div> -->
                    <div class="show-time">
                        <span class="span">{{ item.startAt }}</span>
                        {{ item.zhenFuIntegral ? '' : '开场' }}
                    </div>
                    <div class="end-time">
                        <span class="span">{{ item.endAt }}</span>
                        {{ item.zhenFuIntegral ? '' : '散场' }}
                    </div>
                </div>
                <div class="film">
                    <div class="film-name">{{ item.name }}</div>
                    <div class="film-type">{{ item.showType }}</div>
                </div>
                <div class="price" :class="{ 'no-buy': item.status != 0 }">
                    <div class="sale-price">
                        <template v-if="item.zhenFuIntegral">
                            <span class="zhenfu-buy-price">{{ item.zhenFuBuyPrice }}</span>
                            <span class="zhenfu-symbol">+</span>
                            <span class="zhenfu-intergral">{{ item.zhenFuIntegral }}</span>
                        </template>
                        <template v-else>
                            <span class="text">
                                ¥{{ item.price }}
                                <div class="filme-another" v-if="item.platformShowOptions">
                                    <div
                                        class="filme-commission"
                                        v-for="(v, i) in item.platformShowOptions"
                                        :key="i"
                                    >
                                        <span>
                                            {{ v.key }}
                                            <span class="filme-commission-num">{{ v.value }}</span>
                                        </span>
                                    </div>
                                </div>
                            </span>
                        </template>
                    </div>
                    <div class="market-price">
                        <template v-if="item.zhenFuIntegral">
                            <span class="zhenfu-price">¥{{ item.price }}</span>
                        </template>
                        <span class="line-through" v-if="item.marketPrice != item.price">
                            ¥{{ item.marketPrice }}
                        </span>
                        <div class="save-money" v-if="(item.saveMoney || 0) > 0">
                            省¥{{ item.saveMoney }}
                        </div>
                    </div>
                    <div class="btn" :class="{ 'no-buy': item.status != 0 }">
                        {{ item.status == 0 ? '购票' : '售停' }}
                        <div class="tip">{{ item.showTimeTip }}</div>
                    </div>
                </div>
            </div>
            <div class="filme-none" v-if="filmeList.length == 0">
                <span>无搜索结果！</span>
            </div>
            <Scroll :onBottom="onBottom" :lowerThreshold="200" />
        </div>
        <Share v-if="!$store.state.common.platformId" />
    </div>
</template>
<script>
import number from '@/lib/number';
import Swiper from '@/lib/swiper3.4.2/swiper.min.js';
import '@/lib/swiper3.4.2/swiper.min.css';
import { GET_CINEMA_FOR_MOVIE, GET_MOVIE_INFO_DAY, GET_MOVIE_SCENE_LIST } from 'api';
import {
    PAGE_MOVIE_SEAT_SELECTION,
    PAGE_MOVIE_INFO,
    PAGE_ROOT,
    PAGE_MAP,
    PAGE_CINEMA_INFO,
    PAGE_MAIN_CINEMA,
} from 'page';
import Scroll from '@/components/scroll';
import Share from '@/components/share';
export default {
    data() {
        return {
            movieId: 0,
            cinemaId: 0,
            dateIndex: 0,
            movieList: [],
            filmeName: '',
            filmeAddress: '',
            movieIndex: -1,
            dateList: [],
            filmeList: [],
            pageIndex: 1,
            pageSize: 20,
            isBottom: false,
            cinemaSwiper: null,
            isCreateSwiper: true,
            cinemaSwiperStatus: false,
            // 日期切换是否完成
            isSwiperInit: false,
            lon: 0,
            lat: 0,
        };
    },
    computed: {
        cityId() {
            return this.$store.getters.getCurrentLocation.city.id || 0;
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.isSwiperInit = false;
            if (
                from.path == PAGE_MOVIE_INFO ||
                from.path == PAGE_CINEMA_INFO ||
                from.path == PAGE_MAIN_CINEMA ||
                from.path == PAGE_ROOT
            ) {
                vm.isCreateSwiper = true;
                if (vm.cinemaSwiper) {
                    try {
                        vm.cinemaSwiper.destroy();
                    } catch (error) {}
                }
                vm.$util.debounce(vm.init)();
            } else if (vm.movieList.length == 0) {
                vm.isCreateSwiper = true;
                if (vm.cinemaSwiper) {
                    try {
                        vm.cinemaSwiper.destroy();
                    } catch (error) {}
                }
                vm.$util.debounce(vm.init)();
            }
        });
    },
    watch: {
        cityId() {
            this.$util.debounce(this.init)();
        },
    },
    components: {
        Scroll,
        Share,
    },
    created() {
        this.$util.debounce(this.init)();
    },
    methods: {
        init() {
            this.movieId = this.$route.query.movieId || 0;
            this.cinemaId = this.$route.query.cinemaId || 0;
            // this.dateIndex = this.$route.query.dateIndex || 0;
            this.dateText = this.$route.query.dateText || 0;
            this.cinemaSwiperStatus = false;
            if (this.cityId) {
                this.pageIndex = 1;
                this.filmeList = [];
                this.movieList = [];
                this.getCinemaMovieList();
            }
        },
        // 去地图
        toMap() {
            // let url = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${this.lat},${this.lon};title:${this.filmeName};addr:${this.filmeAddress}&referer=myapp`;
            // window.location.href = url;
            this.$util.pageJump(PAGE_MAP, {
                lat: this.lat,
                lon: this.lon,
                cinemaName: this.filmeName,
                cinemaAddress: this.filmeAddress,
            });
        },
        // 获取影院电影列表
        getCinemaMovieList() {
            this.$util
                .post(GET_CINEMA_FOR_MOVIE, {
                    id: this.cinemaId,
                })
                .then(res => {
                    if (res.success) {
                        console.log(res);
                        this.movieList = [...this.movieList, ...res.data.list];
                        this.filmeName = res.data.name;
                        this.filmeAddress = res.data.address;
                        this.movieIndex = 0;
                        this.lon = res.data.lon;
                        this.lat = res.data.lat;
                        for (let i = 0; i < res.data.list.length; i++) {
                            const item = res.data.list[i];
                            if (item.id == this.movieId) {
                                this.movieIndex = i;
                                break;
                            }
                        }
                        if (this.movieIndex == 0) {
                            this.isSwiperInit = true;
                        }
                        if (this.movieList.length == 0) {
                            this.$toast('该影院暂无影片信息～');
                            return;
                        } else {
                            this.getDateList();
                        }
                    }
                });
        },
        // 点击图片
        clickSwiperImg(index) {
            if (this.cinemaSwiper) {
                this.movieIndex = index;
                this.cinemaSwiper.slideTo(this.movieIndex);
            }
        },
        // 获取日期列表
        getDateList() {
            this.$util
                .post(GET_MOVIE_INFO_DAY, {
                    cityId: this.cityId,
                    movieId: this.movieList[this.movieIndex].id,
                    cinemaId: this.cinemaId,
                })
                .then(res => {
                    if (res.success) {
                        this.dateList = res.data;
                        this.dateIndex = 0;
                        for (let i = 0; i < this.dateList.length; i++) {
                            const item = this.dateList[i];
                            if (item.month + '-' + item.day == this.dateText) {
                                this.dateIndex = i;
                                break;
                            }
                        }
                        this.filmeList = [];
                        this.getFilmeList();
                    }
                });
        },
        // 获取影院电影场次信息
        getFilmeList() {
            let { movieIndex } = this;
            const { cinemaId, movieList, dateList, dateIndex, pageIndex, pageSize, movieId } = this;
            if (!movieIndex && movieIndex != 0) {
                for (let i = 0; i < movieList.length; i++) {
                    const item = movieList[i];
                    if (item.id == movieId) {
                        this.movieIndex = i;
                        movieIndex = i;
                        break;
                    }
                }
            }
            // 无影片信息 不调用
            if (!movieList[movieIndex] || !movieList[movieIndex].id) {
                return;
            }
            // 无日期信息 不调用
            if (!dateList[dateIndex] || !dateList[dateIndex].hasOwnProperty('id')) {
                return;
            } else {
                // 切换当前可用日期为默认
                this.dateText = dateList[dateIndex].month + '-' + dateList[dateIndex].day;
            }
            this.$util
                .post(GET_MOVIE_SCENE_LIST, {
                    cinemaId,
                    movieId: movieList[movieIndex].id,
                    date: dateList[dateIndex].id,
                    pageIndex,
                    pageSize,
                })
                .then(res => {
                    if (res.success) {
                        if (res.data.length < pageSize) {
                            this.isBottom = true;
                        } else {
                            this.isBottom = false;
                        }
                        if (this.$store.getters.platformConfig.platform.useMovieOriginPrice) {
                            for (let i = 0; i < res.data.length; i++) {
                                const item = res.data[i];
                                item._price = this.price;
                                item.price = item.marketPrice;
                            }
                        }
                        for (let i = 0; i < res.data.length; i++) {
                            const item = res.data[i];
                            if (item.enableAuctionMode) {
                                item._price = this.price;
                                item.price = `${item.auctionMinPrice}~${item.auctionMaxPrice}`;
                            } else if (item.enableCompetitionMode) {
                                item.saveMoney =
                                    1 * number.operation(`${item.marketPrice}-${item.price}`);
                            } else {
                                item._price = this.price;
                                item.price = item.marketPrice;
                            }
                            if (this.$store.getters.getExposeMethod.zhenFuMovieListIntegral) {
                                for (let i = 0; i < res.data.length; i++) {
                                    const item = res.data[i];
                                    item.zhenFuIntegral = (
                                        number.operation(`${item.price}*0.05`) * 1
                                    ).toFixed(0);
                                    item.zhenFuBuyPrice = number.operation(
                                        `${item.price}-${item.zhenFuIntegral}`
                                    );
                                }
                            }
                            this.analysisFilmList(res);
                        }
                    }
                });
        },
        analysisFilmList(res) {
            this.filmeList = this.$util.distinct([...this.filmeList, ...res.data], 'id');
            if (this.isCreateSwiper) {
                this.isCreateSwiper = false;
                this.$nextTick(() => {
                    if (this.movieList.length == 0) {
                        return;
                    }
                    this.cinemaSwiper = new Swiper('.swiper-container', {
                        centeredSlides: true,
                        initialSlide: this.movieIndex,
                        centeredSlides: true,
                        observer: true,
                        slidesPerView: 4,
                        loop: false,
                        onClick: () => {
                            this.isSwiperInit = true;
                        },
                        onSlideChangeEnd: swiper => {
                            this.movieIndex = swiper.activeIndex;
                            if (!this.isSwiperInit) {
                                this.isSwiperInit = true;
                                return;
                            }
                            this.pageIndex = 1;
                            this.filmeList = [];
                            this.getDateList();
                        },
                    });
                });
            }
        },
        // 切换日期
        switchDate(index) {
            this.dateIndex = index;
            this.pageIndex = 1;
            this.filmeList = [];
            this.getFilmeList();
        },
        // 去选座
        toSeatSelect(item) {
            if (item.status == 1) {
                this.$toast(`出票需要一定时间，${item.showTimeTip}，避免影响观影。`);
                return;
            }
            this.$util.pageJump(PAGE_MOVIE_SEAT_SELECTION, {
                date: this.dateList[this.dateIndex].id,
                sceneId: item.id,
            });
        },
        // 触底事件
        onBottom() {
            if (this.isBottom) {
                return;
            }
            this.pageIndex++;
            this.getFilmeList();
        },
    },
};
</script>
<style lang="less" scoped>
@import url('~@/lib/base.less');
@swiperHeight: .pxToRem(340) [];
.cinema-room {
    flex-direction: column;
    width: 100%;

    .header {
        justify-content: space-between;
        padding: .pxToRem(16) [] 0;
        .filme-name {
            padding-left: .pxToRem(40) [];
            width: .pxToRem(580) [];
            height: .pxToRem(52) [];
            line-height: .pxToRem(52) [];
            font-size: .pxToRem(32) [];
            color: rgba(0, 0, 0, 0.9);
            .overflow(1);
        }

        .filme-location {
            padding-left: .pxToRem(40) [];
            line-height: .pxToRem(36) [];
            width: .pxToRem(580) [];
            font-size: .pxToRem(24) [];
            color: rgba(0, 0, 0, 0.5);
        }

        .location-img {
            padding: .pxToRem(20) [] .pxToRem(40) [];
            img {
                .sq(44);
            }
        }
    }

    .swipe-box {
        height: @swiperHeight;
        box-sizing: border-box;
        background-color: #c9c9c9;
        position: relative;

        .swiper-container {
            height: @swiperHeight;
            .swiper-wrapper {
                .swiper-slide {
                    .img {
                        .base-center-x;
                        bottom: .pxToRem(65) [];
                        width: .pxToRem(160) [];
                        height: .pxToRem(210) [];
                        border-radius: .pxToRem(18) [];
                    }
                    &.scal {
                        .img {
                            bottom: .pxToRem(50) [];
                            width: .pxToRem(180) [];
                            height: .pxToRem(240) [];
                        }
                    }
                }
            }
        }

        .swipe-bac {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 6.4rem;
            filter: blur(.pxToRem(15) []);
        }

        .swipe-wrap {
            height: .pxToRem(240) [];
            border-radius: .pxToRem(10) [];
            overflow: hidden;
        }

        .cell {
            height: .pxToRem(240) [];
            text-align: center;

            .img {
                width: .pxToRem(180) [];
                height: .pxToRem(251) [];
                background-color: #666;
            }

            .scal {
                width: .pxToRem(184) [];
                height: .pxToRem(255) [];
                margin-top: .pxToRem(-10) [];
            }
        }

        &:after {
            content: ' ';
            .base-center-x;
            bottom: .pxToRem(-8) [];
            .sq(32);
            background: url('~@/assets/icons/icon-top-triangle.png');
            background-size: cover;
            z-index: 10;
        }
    }

    .cinema-content {
        text-align: center;
        padding: 0 .pxToRem(30) [] 0 .pxToRem(30) [];
        background: white;
        .cinema-name {
            padding-top: .pxToRem(18) [];
            font-size: .pxToRem(40) [];
            font-weight: bold;
            color: rgba(0, 0, 0, 0.9);
            line-height: .pxToRem(56) [];

            .grade {
                color: rgba(255, 134, 12, 1);
                margin-left: .pxToRem(18) [];
            }
        }

        .cinema-detail {
            font-size: .pxToRem(26) [];
            font-weight: 500;
            color: rgba(169, 169, 169, 1);
            line-height: .pxToRem(36) [];
            display: block;
            min-width: .pxToRem(700) [];
            padding-bottom: .pxToRem(28) [];
            .overflow(1);
        }
    }

    .date-list {
        justify-content: space-around;
        height: .pxToRem(88) [];
        padding: 0 .pxToRem(30) [];
        .date-item {
            flex: 1;
            text-align: center;
            height: .pxToRem(88) [];
            line-height: .pxToRem(88) [];
            font-size: .pxToRem(28) [];
            color: rgba(0, 0, 0, 0.5);
            .text {
                display: inline-block;
            }
            .week {
                margin-right: .pxToRem(10) [];
                font-size: .pxToRem(26) [];
            }
            .date {
                font-size: .pxToRem(28) [];
            }
            &.select {
                color: rgba(0, 0, 0, 0.9);
                font-weight: bold;
                .text {
                    &:after {
                        content: ' ';
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        height: .pxToRem(4) [];
                        background: #f8c32f;
                    }
                }
            }
        }
        &.more-date {
            display: block;
            justify-content: flex-start;
            white-space: nowrap;
            overflow-x: auto;
            .date-item {
                display: inline-block;
                margin-right: .pxToRem(60) [];
                &:last-child {
                    margin-right: 0;
                }
            }
        }
        &:after {
            content: ' ';
            position: absolute;
            bottom: 0;
            left: .pxToRem(40) [];
            right: .pxToRem(40) [];
            height: .pxToRem(1) [];
            background: rgba(0, 0, 0, 0.1);
        }
    }

    .filme-list {
        padding-top: .pxToRem(30) [];
        padding-left: .pxToRem(30) [];
        padding-right: .pxToRem(30) [];
        .filme-item {
            display: flex;
            background: white;
            margin-bottom: .pxToRem(20) [];
            border-radius: .pxToRem(40) [];
            overflow: hidden;
            .time {
                position: absolute;
                top: .pxToRem(24) [];
                left: .pxToRem(32) [];
                display: flex;
                .show-tip {
                    width: .pxToRem(110) [];
                    height: .pxToRem(36) [];
                    line-height: .pxToRem(36) [];
                    margin-top: .pxToRem(20) [];
                    margin-bottom: .pxToRem(-16) [];
                    text-align: center;
                    padding: .pxToRem(5) [];
                    font-size: .pxToRem(24) [];
                    border: .pxToRem(1) [] solid rgba(0, 0, 0, 0.9);
                    color: rgba(0, 0, 0, 0.9);
                    border-radius: .pxToRem(8) [];
                }

                .show-time,
                .end-time {
                    height: .pxToRem(56) [];
                    line-height: .pxToRem(56) [];
                    font-size: .pxToRem(24) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.5);
                }
                .show-time .span,
                .end-time .span {
                    height: .pxToRem(56) [];
                    line-height: .pxToRem(56) [];
                    font-size: .pxToRem(34) [];
                    font-weight: 600;
                    color: rgba(0, 0, 0, 0.9);
                }
                .show-time {
                    margin-right: .pxToRem(42) [];
                    &::after {
                        content: ' ';
                        position: absolute;
                        top: .pxToRem(8) [];
                        right: .pxToRem(-39) [];
                        background-image: url('~@/assets/icons/icon-move-right.png');
                        background-size: contain;
                        width: .pxToRem(34) [];
                        height: .pxToRem(32) [];
                    }
                }
            }
            .film {
                box-sizing: border-box;
                padding: .pxToRem(88) [] 0 .pxToRem(24) [] .pxToRem(32) [];
                flex: 1;
                max-width: .pxToRem(320) [];
                .film-name {
                    line-height: .pxToRem(32) [];
                    font-size: .pxToRem(24) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.5);
                }
                .film-type {
                    line-height: .pxToRem(36) [];
                    font-size: .pxToRem(24) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.9);
                }
            }
            .price {
                flex: 1;
                padding-right: .pxToRem(24) [];
                .sale-price {
                    text-align: right;
                    height: .pxToRem(36) [];
                    line-height: .pxToRem(36) [];
                    font-size: .pxToRem(36) [];
                    font-weight: 600;
                    color: #d90209;
                    margin-top: .pxToRem(34) [];
                    .text {
                        text-align: right;
                    }
                    .zhenfu-buy-price {
                        &:before {
                            content: '¥';
                            // font-size: .pxToRem(24) [];
                            margin-right: .pxToRem(4) [];
                        }
                    }
                    .zhenfu-symbol {
                        color: #999;
                        font-size: .pxToRem(24) [];
                        top: .pxToRem(-4) [];
                        padding: 0 .pxToRem(4) [];
                    }
                    .zhenfu-intergral {
                        padding-left: .pxToRem(40) [];
                        &:before {
                            content: ' ';
                            .base-center-y;
                            left: 0;
                            .sq(36);
                            background: url('~@/assets/icons-platform/icon-zhenfu-h.jpg');
                            background-size: cover;
                        }
                    }
                }
                .market-price {
                    text-align: right;
                    margin-top: .pxToRem(16) [];
                    margin-bottom: .pxToRem(12) [];
                    height: .pxToRem(36) [];
                    line-height: .pxToRem(36) [];
                    font-size: .pxToRem(22) [];
                    color: rgba(0, 0, 0, 0.3);
                    font-weight: 400;
                    .line-through {
                        text-decoration: line-through;
                    }
                    .zhenfu-price {
                        color: #000;
                        margin-right: .pxToRem(20) [];
                    }
                }
                .save-money {
                    display: inline-block;
                    height: .pxToRem(32) [];
                    line-height: .pxToRem(32) [];
                    font-size: .pxToRem(22) [];
                    border: .pxToRem(2) [] solid #d90209;
                    border-radius: .pxToRem(19) [] .pxToRem(19) [] 0 .pxToRem(20) [];
                    font-weight: 400;
                    color: #d90209;
                    padding: 0 .pxToRem(17) [];
                    margin-left: .pxToRem(12) [];
                }
                .tip {
                    display: none;
                    position: absolute;
                    left: .pxToRem(-12)[];
                    top: 50%;
                    transform: translate(-100%, -50%);
                    height: .pxToRem(32) [];
                    line-height: .pxToRem(32) [];
                    font-size: .pxToRem(22) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.3);
                }
                .btn {
                    width: .pxToRem(115) [];
                    height: .pxToRem(64) [];
                    line-height: .pxToRem(64) [];
                    text-align: center;
                    background: #fcdb28;
                    border-radius: .pxToRem(30) [];
                    font-weight: 400;
                    font-size: .pxToRem(26) [];
                    color: rgba(0, 0, 0, 0.9);
                    float: right;
                    margin-bottom: .pxToRem(16) [];
                    &.no-buy {
                        font-size: .pxToRem(26) [];
                        background: rgba(0, 0, 0, 0.1);
                        color: rgba(0, 0, 0, 0.15);
                    }
                }
                &.no-buy {
                    .market-price {
                        display: none;
                    }
                    .save-money {
                        display: none;
                    }
                    .tip {
                        display: block;
                    }
                }
            }
        }
    }
    .filme-another {
        .base-center-y;
        left: .pxToRem(-8) [];
    }
    .filme-commission {
        font-size: .pxToRem(24) [];
        color: #d90209;
        font-weight: 400;
        transform: translateX(-100%);
        white-space: nowrap;
    }
    .filme-none {
        text-align: center;
        margin-top: .pxToRem(120) [];
        color: rgba(153, 153, 153, 1);
        font-size: .pxToRem(30) [];
    }
}
</style>
